<template>
  <div class="noOpenCityWrap">
    <div class="empty" :style="{ paddingTop: headerHeight + 'px' }"></div>
    <div v-if="imgUrl" class="bannerBox">
      <img :src="imgUrl" class="bannerImg" />
    </div>
    <div class="messageBox">
      <h5>{{ $t('FoodC_cancellation_Ezrs_LhQu') }}</h5>
      <p>{{ $t('FoodC_cancellation_NLzA_tDER') }}</p>
    </div>
    <CancelEntry v-if="hasTransNationalInfo" />
  </div>
</template>

<script>
import CancelEntry from './cancel-entry.vue'

export default {
  components: {
    CancelEntry,
  },
  props: {
    headerHeight: {
      type: Number,
      default: 0,
    },
    imgUrl: {
      type: String,
      default: '',
    },
    hasTransNationalInfo: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.noOpenCityWrap {
  padding-bottom: 50px;
}
.bannerBox {
  padding-top: 40px;
  display: flex;
  justify-content: center;
  img {
    width: 670px;
  }
}
.messageBox {
  padding: 130px 40px 60px 40px;
  h5 {
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 40px;
    line-height: 56px;
    text-align: center;
    letter-spacing: normal;
    color: #000000;
  }
  p {
    padding-top: 8px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    letter-spacing: normal;
    color: #0b0b0d;
  }
}
</style>
